import axios from '../utils/axios';
/**
 * 获取问卷列表  (弃用)
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getRiskQuestions(data, au) {
  return axios('/ttd-fund-question/question/list', data, au);
}
/**
 * 问卷、问题列表
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getRiskQuestionsNew(data, au) {
  return axios('/ttd-fund-question/question/new/list', data, au);
}
/**
 * 计算测评分数和结果
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getRiskQuestionsCal(data, au) {
  return axios('/ttd-fund-question/evaluation/calculation', data, au);
}
/**
 * 获取风险不匹配订单
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getRiskNoMatchOrder(data, au) {
  return axios('/ttd-fund-order/order/no/match', data, au);
}
/**
 * 保存问卷结果
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getRiskSave(data, au) {
  return axios('/ttd-fund-question/evaluation/save', data, au);
}
/**
 * 风险测评问卷签字
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getRiskSign(data, au) {
  return axios('/ttd-fund-question/evaluation/setEvaluationResultFileSign', data, au);
}
